module.exports = __webpack_public_path__ + "static/media/image-placeholder.fcd20df4.jpg";